module.exports = __webpack_public_path__ + "static/img/wzqc-02.a27a782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wzqc-02.png
// module id = 155
// module chunks = 1